import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";
import { listUserCompanies } from "../../graphql";

export const listusercompaniesApi = createApi({
  reducerPath: "companylist",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    fetchCompanylist: builder.query({
        query: () => ({ body: listUserCompanies }),
      keepUnusedDataFor: Infinity,
      refetchOnMountOrArgChange: true,
      providesTags: ["Companylist"],
    }),
  }),
});

export const {
  useFetchCompanylistQuery,
} = listusercompaniesApi;
